export interface Product {
  id: string;
  slug: string;
  name: string;
  category: string;
  badge?: string;
  image: string;
  galleryImages?: string[];
  specs: {
    potencia: string;
    velocidade: string;
    temperatura: string;
    material: string;
  };
  extraSpecs?: Record<string, string>;
  techFeatures?: { title: string; description: string }[];
  compatibilidade: {
    pead: boolean;
    pvc: boolean;
    lldpe: boolean;
  };
  description: string;
  features: string[];
  applications: string[];
}

export const products: Product[] = [
  {
    id: 'bt950',
    slug: 'bt950',
    name: 'BT950',
    category: 'Cunha Quente',
    badge: 'Top Venda',
    image: 'https://public.readdy.ai/ai/img_res/eb2da247-3e5a-4cfd-bb34-9a8596111e8d.png',
    specs: {
      potencia: '2100W / 220V',
      velocidade: '5–8 m/min',
      temperatura: '0–500°C',
      material: '500–3000 µm',
    },
    compatibilidade: { pead: true, pvc: true, lldpe: true },
    description:
      'A BT950 é a cunha quente mais vendida do nosso catálogo, ideal para obras de grande porte que exigem alta produtividade. Com potência de 2100W e velocidade de até 8 m/min, solda geomembranas de PEAD, PVC e LLDPE com acabamento profissional e controle preciso de temperatura.',
    features: [
      'Potência de 2100W para soldagem contínua em grandes áreas',
      'Velocidade de até 8 m/min para máxima produtividade em obra',
      'Controle de temperatura de 0 a 500°C com ajuste fino',
      'Compatível com PEAD, PVC e LLDPE de 500 a 3000 µm',
      'Solda dupla que atende aos requisitos da norma NBR 16199',
    ],
    applications: ['Aterros sanitários', 'Lagoas de impermeabilização', 'Mineração e contenção'],
  },
  {
    id: 'bt1600',
    slug: 'bt1600',
    name: 'BT1600',
    category: 'Cunha Quente',
    image: 'https://public.readdy.ai/ai/img_res/8052ee80-0fc2-406f-8f41-69dc01cd61a5.png',
    specs: {
      potencia: '1600W / 220V',
      velocidade: '0–5 m/min',
      temperatura: '0–450°C',
      material: '400–2000 µm',
    },
    compatibilidade: { pead: true, pvc: true, lldpe: true },
    description:
      'A BT1600 é uma cunha quente equilibrada entre potência e portabilidade, perfeita para obras de médio porte e manutenção. Oferece soldagem precisa de geomembranas entre 400 e 2000 µm com ajuste de temperatura até 450°C.',
    features: [
      'Potência de 1600W com excelente relação custo-benefício',
      'Velocidade regulável de 0 a 5 m/min para controle total',
      'Temperatura ajustável de 0 a 450°C',
      'Compatível com PEAD, PVC e LLDPE',
      'Leve e ergonômica, ideal para deslocamento em campo',
    ],
    applications: ['Piscicultura', 'Saneamento básico', 'Impermeabilização de tanques'],
  },
  {
    id: 'bt800',
    slug: 'bt800',
    name: 'BT800',
    category: 'Cunha Quente',
    image: 'https://public.readdy.ai/ai/img_res/de9df2b2-9966-4ae3-af7d-fedfb7e975a3.png',
    specs: {
      potencia: '800W / 220V',
      velocidade: '2–5 m/min',
      temperatura: '0–400°C',
      material: '500–1500 µm',
    },
    compatibilidade: { pead: true, pvc: false, lldpe: true },
    description:
      'A BT800 é a opção de entrada da linha de cunha quente, ideal para quem inicia no mercado de geomembranas ou trabalha com membranas mais finas. Solda PEAD e LLDPE de 500 a 1500 µm com confiabilidade e baixo consumo.',
    features: [
      'Potência de 800W com baixo consumo de energia',
      'Velocidade de 2 a 5 m/min para trabalhos controlados',
      'Temperatura de 0 a 400°C',
      'Indicada para PEAD e LLDPE',
      'Excelente para projetos de menor porte e iniciantes',
    ],
    applications: ['Reservatórios agrícolas', 'Canais de irrigação', 'Pequenas impermeabilizações'],
  },
  {
    id: 'cx300-1400w',
    slug: 'cx300-1400w',
    name: 'CX300 1400W',
    category: 'Cunha Quente',
    image: 'https://public.readdy.ai/ai/img_res/aa9941d2-1b65-4b0c-9946-58189521c260.png',
    galleryImages: [
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/359e0cc8820cc19b3b704720da34e8f3.jpeg',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/3e6033947d3cd7c1ec200e095937d4b5.jpeg',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/aa1ad20617b80ecbd284c487f86f8560.jpeg',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/3048c3015877f0a523253e3a541d3a82.jpeg',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/d8f9161c8a8940b93fd6a435ef730ec2.jpeg',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/b0331ade6c78fbb3fcf7b8552a2c7dd8.png',
    ],
    specs: {
      potencia: '1400W / 220V',
      velocidade: '0–8 m/min',
      temperatura: '0–450°C',
      material: '500–1500 µm',
    },
    extraSpecs: {
      'Frequência': '50 Hz',
      'Comprimento da cunha': '70 mm',
      'Largura da solda': '15 mm × 2',
      'Cavidade interna': '12 mm',
      'Largura de sobreposição': '100 mm',
      'Resistência da solda': '≥85% do material original',
      'Peso líquido': '7 kg',
      'Profundidade máxima de trabalho': '50 mm',
    },
    techFeatures: [
      {
        title: 'Estrutura Principal em Alumínio de Aviação',
        description:
          'O quadro principal é feito de alumínio de aviação, fundido sob pressão (die-cast) e pintado na superfície, sendo leve e extremamente resistente.',
      },
      {
        title: 'Rolamentos de Precisão',
        description:
          'A posição dos rolamentos e os furos dos parafusos são usinados em CNC, utilizando rolamentos de agulha IKO japoneses e rolamentos de esferas NSK alemães de ranhura profunda.',
      },
      {
        title: 'Tela de Display Digital',
        description:
          'A temperatura e a velocidade são controladas por programação de chip de computador, e a tela LCD exibe digitalmente a temperatura e a velocidade em tempo real.',
      },
      {
        title: 'Ajuste de Pressão Ergonômico',
        description:
          'O design de duplo punho é ergonômico, e a porca de pressão é equipada com uma mola de alta resistência para ajuste fácil e preciso durante a soldagem.',
      },
      {
        title: 'Cunha Quente de Cobre',
        description:
          'Equipada com uma cunha quente de cobre cuja condutividade térmica é 4 vezes maior que a do latão. O cobre tem boa viscosidade e os parafusos de fixação não soltam facilmente.',
      },
      {
        title: 'Cartucho de Aquecimento Curvo',
        description:
          'A profundidade de trabalho da máquina é de 50 mm (água menor ou igual a 50 mm não queimará a máquina). O cartucho de aquecimento adota um design de tubo curvo para melhor distribuição do calor.',
      },
    ],
    compatibilidade: { pead: true, pvc: true, lldpe: true },
    description:
      'A CX300 1400W é uma cunha quente versátil e robusta, projetada para soldar geomembranas de 500 a 1500 µm em aplicações variadas. Permite soldagem unilateral (same side), onde as duas folhas são soldadas pelo mesmo lado, e também soldagem bilateral (both sides), com emendas esquerda e direita para sobreposição. Seu controle de temperatura até 450°C garante soldas homogêneas em PEAD, PVC e LLDPE. Com estrutura em alumínio de aviação, rolamentos de precisão japoneses e alemães, display digital e cunha quente de cobre de alta condutividade térmica, oferece desempenho profissional em campo.',
    features: [
      'Potência de 1400W para desempenho estável',
      'Velocidade de 0 a 8 m/min com ajuste preciso',
      'Temperatura de 0 a 450°C com display digital',
      'Compatível com PEAD, PVC e LLDPE',
      'Estrutura em alumínio de aviação — leve e resistente',
      'Rolamentos IKO (Japão) e NSK (Alemanha) de precisão CNC',
      'Cunha quente de cobre com condutividade 4× superior ao latão',
      'Resistência da solda ≥85% do material original',
      'Solda do mesmo lado (same side) e de lados diferentes (both sides) — máquina de dupla finalidade',
      'Peso de apenas 7 kg — portátil e fácil de transportar em obra',
      'Design americano robusto com peças europeias de alta precisão',
    ],
    applications: ['Saneamento', 'Aterros de pequeno porte', 'Impermeabilização de lajes', 'Lagoas de biogás', 'Coberturas de aterros'],
  },
  {
    id: 'cx500l',
    slug: 'cx500l',
    name: 'CX500L',
    category: 'Cunha Quente',
    image: 'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/04da523dda28bc8e70f9ac5b2625c443.png',
    galleryImages: [
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/6c7e63300ad0aa1c605a9248f11b3ef4.jpeg',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/fbc9a24e4051c6331f536b5b92931c8b.png',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/60a45452adb8ece2dd4dfcba4c64e032.png',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/8cce919873017217714f377009e7e970.png',
    ],
    specs: {
      potencia: '1800W / 220V',
      velocidade: '0–6 m/min',
      temperatura: '0–450°C',
      material: '0,8–3 mm',
    },
    extraSpecs: {
      'Frequência': '50 Hz',
      'Largura de sobreposição': '120 mm',
      'Largura da solda': '15 mm × 2',
      'Cavidade interna': '16 mm',
      'Resistência da solda': '≥85% do material original',
      'Peso líquido': '11 kg',
    },
    techFeatures: [
      {
        title: 'Estrutura Principal em Alumínio de Aviação',
        description:
          'O quadro principal é feito de alumínio de aviação, fundido sob pressão (die-cast) e pintado na superfície, sendo leve e extremamente resistente.',
      },
      {
        title: 'Rolamentos de Precisão',
        description:
          'A posição dos rolamentos e os furos dos parafusos são usinados em CNC, utilizando rolamentos de agulha IKO japoneses e rolamentos de esferas NSK alemães de ranhura profunda.',
      },
      {
        title: 'Cunha Quente em Cobre e Latão',
        description:
          "A cunha quente está disponível em cobre e latão. O design de tubo curvo é à prova d'água, e os parafusos de fixação são preenchidos com escudos de silicone.",
      },
      {
        title: 'Guia de Trilho Robusta',
        description:
          'O trilho inferior de apoio é uma roda excêntrica, a roda superior de pressão possui mola, e o trilho guia é um eixo de aço inoxidável com manga de cobre, com forte durabilidade.',
      },
      {
        title: 'Ajuste de Pressão Ergonômico',
        description:
          'O design de duplo punho é ergonômico, e a porca de pressão é equipada com uma mola de alta resistência para ajuste fácil e preciso durante a soldagem.',
      },
      {
        title: 'Roda Excêntrica Ajustável',
        description:
          'A roda excêntrica pode ser ajustada de acordo com a espessura do filme, garantindo pressão uniforme em diferentes espessuras de geomembrana.',
      },
    ],
    compatibilidade: { pead: true, pvc: true, lldpe: true },
    description:
      'A CX500L é uma cunha quente de dupla finalidade, permitindo soldagem unilateral (same side) alimentando a geomembrana pelo mesmo lado, ideal para tampeamento de tanques de biogás e aterros sanitários. Além disso, suporta soldagem de sobreposição (overlap welding), onde a geomembrana pode ser alimentada pelos dois lados (esquerda e direita). Com potência de 1800W e peso de 11 kg, é uma máquina versátil e robusta para geomembranas de 0,8 a 3 mm em PEAD, PVC e LLDPE.',
    features: [
      'Potência de 1800W para desempenho estável em grandes áreas',
      'Velocidade de 0 a 6 m/min com ajuste preciso',
      'Temperatura de 0 a 450°C para diferentes espessuras',
      'Compatível com PEAD, PVC e LLDPE de 0,8 a 3 mm',
      'Estrutura em alumínio de aviação — leve e resistente',
      'Rolamentos IKO (Japão) e NSK (Alemanha) de precisão CNC',
      'Cunha quente em cobre e latão com tubo curvo à prova d\'água',
      'Resistência da solda ≥85% do material original',
      'Solda do mesmo lado (same side) e de lados diferentes (both sides) — máquina de dupla finalidade',
      'Peso de 11 kg — portátil e fácil de transportar em obra',
      'Roda excêntrica ajustável conforme espessura do filme',
      'Trilho guia de aço inoxidável com manga de cobre para durabilidade',
    ],
    applications: ['Aterros sanitários', 'Mineração e contenção', 'Tanques de biogás', 'Lagoas de impermeabilização', 'Barragens e reservatórios'],
  },
  {
    id: 'bt-gm1',
    slug: 'bt-gm1',
    name: 'BT-GM1',
    category: 'Cunha Quente',
    badge: 'Novo',
    image: 'https://public.readdy.ai/ai/img_res/b2ad4c27-4a71-43f8-916b-509c5e7c9eeb.png',
    specs: {
      potencia: '1800W / 220V',
      velocidade: '0,5–7 m/min',
      temperatura: '0–550°C',
      material: '500–2000 µm',
    },
    compatibilidade: { pead: true, pvc: true, lldpe: true },
    description:
      'A BT-GM1 é o lançamento da linha SoldaGeo, desenvolvida para atender a soldagem de geomembranas com temperatura elevada de até 550°C. Combina potência de 1800W com versatilidade para PEAD, PVC e LLDPE.',
    features: [
      'Temperatura máxima de 550°C para materiais exigentes',
      'Potência de 1800W com desempenho estável',
      'Velocidade de 0,5 a 7 m/min',
      'Compatível com PEAD, PVC e LLDPE',
      'Design atualizado com componentes de alta durabilidade',
    ],
    applications: ['Impermeabilização industrial', 'Mineração', 'Saneamento'],
  },
  {
    id: 'extrusora-ex3',
    slug: 'extrusora-ex3',
    name: 'Extrusora EX3',
    category: 'Extrusora',
    badge: 'Extrusão',
    image: 'https://public.readdy.ai/ai/img_res/9c56e8bf-8fe4-4af3-8989-cd97364c0d78.png',
    specs: {
      potencia: '3400W',
      velocidade: '3,5 kg/h',
      temperatura: '0–700°C',
      material: 'Ø 3,0–4,0 mm',
    },
    compatibilidade: { pead: true, pvc: false, lldpe: true },
    description:
      'A Extrusora EX3 é ideal para soldagem por extrusão em cantos, detalhes e reparos onde a cunha quente não alcança. Com potência de 3400W e temperatura de até 700°C, aplica cordões de PEAD e LLDPE com vazão de 3,5 kg/h.',
    features: [
      'Potência de 3400W para extrusão contínua',
      'Temperatura de 0 a 700°C para fusão completa do material',
      'Vazão de 3,5 kg/h com aplicação uniforme',
      'Indicada para PEAD e LLDPE em cordões de 3,0 a 4,0 mm',
      'Perfeita para reparos, cantos e espessuras acima de 2 mm',
    ],
    applications: ['Reparos de geomembrana', 'Soldagem de cantos e detalhes', 'Geomembranas espessas'],
  },
  {
    id: 'bt2000d',
    slug: 'bt2000d',
    name: 'BT2000D',
    category: 'Acessório',
    badge: 'Acessório',
    image: 'https://public.readdy.ai/ai/img_res/37258b53-e3dd-4be1-b20b-341c04bbece7.png',
    specs: {
      potencia: '2000W / 220V',
      velocidade: 'Manual',
      temperatura: '0–650°C',
      material: '200–2000 µm',
    },
    compatibilidade: { pead: true, pvc: true, lldpe: true },
    description:
      'O BT2000D com rolo de silicone é o acessório essencial para acabamento e soldagem manual de geomembranas. Com temperatura de até 650°C, permite pré-aquecimento e soldagem de sobreposições em PEAD, PVC e LLDPE.',
    features: [
      'Potência de 2000W com aquecimento rápido',
      'Temperatura de 0 a 650°C para materiais diversos',
      'Rolo de silicone incluso para pressão uniforme',
      'Compatível com PEAD, PVC e LLDPE de 200 a 2000 µm',
      'Ideal para acabamento e soldagem de pequenos trechos',
    ],
    applications: ['Acabamento de soldas', 'Reparos pontuais', 'Soldagem manual de sobreposições'],
  },
  {
    id: 'extrusora-metabo-bt610a',
    slug: 'extrusora-metabo-bt610a',
    name: 'Extrusora Metabo BT610A',
    category: 'Extrusora',
    badge: 'Novo Modelo',
    image: 'https://public.readdy.ai/ai/img_res/76fedaaa-0cf5-49b9-82b9-1e6bb130c200.png',
    specs: {
      potencia: '3400W',
      velocidade: 'Manual',
      temperatura: '0–600°C',
      material: '3–4 mm',
    },
    compatibilidade: { pead: true, pvc: false, lldpe: false },
    description:
      'A Extrusora Metabo BT610A une a confiabilidade da marca Metabo à soldagem por extrusão de PEAD. Com potência de 3400W e temperatura de até 600°C, é indicada para reparos e soldagem de detalhes em geomembranas de polietileno.',
    features: [
      'Marca Metabo, referência em ferramentas profissionais',
      'Potência de 3400W para extrusão eficiente',
      'Temperatura de 0 a 600°C',
      'Indicada para PEAD em cordões de 3 a 4 mm',
      'Robustez para uso contínuo em campo',
    ],
    applications: ['Reparos de geomembrana PEAD', 'Soldagem de detalhes', 'Manutenção de obras'],
  },
  {
    id: 'lc3000c',
    slug: 'lc3000c',
    name: 'LC3000C',
    category: 'Ar Quente',
    badge: 'Lona de PVC',
    image: 'https://public.readdy.ai/ai/img_res/6b3b7a34-c45a-4d03-b4b0-092cb3216897.png',
    specs: {
      potencia: '1800W / 220V',
      velocidade: '3–7 m/min',
      temperatura: '0–600°C',
      material: '400–1100 µm',
    },
    compatibilidade: { pead: false, pvc: true, lldpe: false },
    description:
      'A LC3000C é uma máquina de solda por ar quente de alta pressão, desenvolvida exclusivamente para a soldagem de lona de PVC (banners, toldos, coberturas, lonas de caminhão e estruturas tensionadas). Não é uma cunha quente e não é indicada para geomembrana. Com temperatura de até 600°C e potência de 1800W, sela emendas de lona de PVC de 400 a 1100 µm com acabamento uniforme e profissional.',
    features: [
      'Solda por ar quente de alta pressão — não é cunha quente',
      'Temperatura de 0 a 600°C para soldagem de lona de PVC',
      'Potência de 1800W com aquecimento estável',
      'Velocidade de 3 a 7 m/min',
      'Exclusiva para lona de PVC (não indicada para geomembrana)',
    ],
    applications: ['Lonas de PVC', 'Banners e toldos', 'Coberturas e estruturas tensionadas'],
  },
  {
    id: 'weldy-wgw300-plus',
    slug: 'weldy-wgw300-plus',
    name: 'Weldy WGW300 Plus',
    category: 'Cunha Quente',
    badge: 'Alta Velocidade',
    image: 'https://public.readdy.ai/ai/img_res/e501f0de-ff51-4c08-9139-a4a2473d5a2f.png',
    specs: {
      potencia: '2000W / 220V',
      velocidade: '4–8 m/min',
      temperatura: '0–520°C',
      material: '500–3000 µm',
    },
    compatibilidade: { pead: true, pvc: true, lldpe: true },
    description:
      'A Weldy WGW300 Plus é uma cunha quente de alta velocidade e desempenho, com potência de 2000W e velocidade de até 8 m/min. Solda geomembranas de 500 a 3000 µm em PEAD, PVC e LLDPE com alta confiabilidade e precisão.',
    features: [
      'Alta velocidade de 4 a 8 m/min para grandes obras',
      'Potência de 2000W com aquecimento eficiente',
      'Temperatura de 0 a 520°C',
      'Compatível com PEAD, PVC e LLDPE até 3000 µm',
      'Tecnologia Weldy de precisão e durabilidade',
    ],
    applications: ['Aterros sanitários', 'Mineração', 'Grandes áreas de impermeabilização'],
  },
  {
    id: 'extrusora-weldy-booster-ex3-plus',
    slug: 'extrusora-weldy-booster-ex3-plus',
    name: 'Extrusora Weldy Booster EX3 Plus',
    category: 'Extrusora',
    badge: 'Acessório',
    image: 'https://public.readdy.ai/ai/img_res/8f07c99f-1079-441c-b556-7d8e1e6218b9.png',
    specs: {
      potencia: '3400W / 220V',
      velocidade: 'Manual',
      temperatura: '0–600°C',
      material: '3–4 mm',
    },
    compatibilidade: { pead: true, pvc: false, lldpe: true },
    description:
      'A Extrusora Weldy Booster EX3 Plus é a opção de alta potência da linha Weldy para soldagem por extrusão. Com 3400W e temperatura de até 600°C, aplica cordões de PEAD e LLDPE de 3 a 4 mm em reparos e detalhes.',
    features: [
      'Potência de 3400W para extrusão de alta vazão',
      'Temperatura de 0 a 600°C',
      'Compatível com PEAD e LLDPE',
      'Cordões de 3 a 4 mm com aplicação controlada',
      'Linha Weldy, reconhecida pela durabilidade',
    ],
    applications: ['Reparos de geomembrana', 'Soldagem de cantos', 'Detalhes em PEAD e LLDPE'],
  },
];